import { BellIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";

import { PAGE_PATHS } from "@/constants";
import { useUnreadCount } from "@/services";

/** 99 dan ortig'i raqam sifatida hech narsa qo'shmaydi, faqat joy egallaydi. */
const MAX_BADGE = 99;

export const NotificationBell = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: unread = 0 } = useUnreadCount();

  const label =
    unread > 0
      ? t("NOTIFICATIONS.UNREAD_ARIA", { count: unread })
      : t("NOTIFICATIONS.NO_UNREAD_ARIA");

  return (
    <Button
      variant="ghost"
      size="icon-sm"
      className="relative"
      aria-label={label}
      title={label}
      onClick={() => navigate(PAGE_PATHS.NOTIFICATIONS)}
    >
      <BellIcon className="size-4" />
      {unread > 0 && (
        <span className="bg-destructive text-destructive-foreground absolute -top-0.5 -right-0.5 grid min-w-4 place-items-center rounded-full px-1 text-[10px] leading-4 font-semibold">
          {unread > MAX_BADGE ? `${MAX_BADGE}+` : unread}
        </span>
      )}
    </Button>
  );
};
